import React,{useState, useEffect} from "react";
import { Form, Button, Label } from 'semantic-ui-react';
import { HTTPURL, REQUEST_OPTIONS, REQUEST_OPTIONS_NO_HEAD } from "../../constants/matcher";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import "../../css/ProfileSetting.css";

const Setting = () => {
    const [show, setShow] = useState(false);
    const [education, setEducation] = useStateWithCallbackLazy([]);
    const [image, setImage] = useState({ preview: '', data: '' });
    const [workVocation, setWorkVocation] = useStateWithCallbackLazy([]);
    const [category, setAllCategory] = useStateWithCallbackLazy([]);
    const [subCategory, setsubCategory] = useStateWithCallbackLazy([]);
    const {
        register,
        getValues,
        setValue,
        handleSubmit,
        formState: { errors },
        reset,
        watch,  
    } = useForm();

    // get category form server side 
    useEffect(() => {
        const fetchData = async () => 
        {
            return await fetch(HTTPURL+'user/get-all-category')
            .then((response) => response.json())
            .then((data) =>  {
                setAllCategory(data.category, () => {
                    setValue('category', userData[0].category);
                });
                setsubCategory(data.subcategory, () => {
                    setValue('subcategory', userData[0].subcategory);
                });
                setEducation(data.education, () => {
                    setValue('education', userData[0].education);
                });
                setWorkVocation(data.state, () => {
                    setValue('workVocation', userData[0].workVocation);
                });
            });
        }
        fetchData();
        
        // get user loggedin profile data from users table 
        const userData = JSON.parse(localStorage.getItem("user-data"));
        setImage({preview: userData[0].photo});
        setValue('id', userData[0].id);
        setValue('firstName', userData[0].firstName,{ shouldDirty: true });
        setValue('middleName', userData[0].middleName);
        setValue('lastName', userData[0].lastName);
        setValue('gender', userData[0].gender);
        let myDate = new Date(userData[0].dob).toISOString().slice(0, 10);
        setValue('dob', myDate);
        setValue('phone', userData[0].phone);
        setValue('email', userData[0].email);
        setValue('existphotoName', userData[0].photo);
        setValue('education', userData[0].education);
        setValue('workVocation', userData[0].workVocation);
    },[]);

    const handleFileChange = (e) => {
        const img = {
          preview: URL.createObjectURL(e.target.files[0]),
          data: e.target.files[0],
        }
        setImage(img);
        setShow(true);
    }

    const handleSubmitRegImgNIU = async (e) => {
        e.preventDefault()
        let formData = new FormData()
        formData.append('file', image.data)
        formData.append('firstName', getValues("firstName"));
    }

    const onSubmit = (data) => {
        let formData = new FormData()
        formData.append('id', getValues("id"));
        formData.append('photo', getValues("photo"));
        formData.append('file', image.data)
        formData.append('firstName', getValues("firstName"));
        formData.append('middleName', getValues("middleName"));
        formData.append('lastName', getValues("lastName"));
        formData.append('gender', getValues("gender"));
        formData.append('dob', getValues("dob"));
        formData.append('phone', getValues("phone"));
        formData.append('email', getValues("email"));
        formData.append('education', getValues("education"));
        formData.append('workVocation', getValues("workVocation"));
        formData.append('state', getValues("state"));
        formData.append('category', getValues("category"));
        formData.append('subcategory', getValues("subcategory"));
        formData.append('existphotoName', getValues("existphotoName"));
        componentDidMount(formData);
    }

    const componentDidMount = (requestData) =>
    {
        REQUEST_OPTIONS_NO_HEAD.method = 'POST';
        REQUEST_OPTIONS_NO_HEAD.body = requestData;

          fetch(HTTPURL+'user/update-profile', REQUEST_OPTIONS_NO_HEAD)
          .then(async response => {
              const isJson = response.headers.get('content-type')?.includes('application/json');
              const data = isJson && await response.json();
                if (!response.ok) 
                {
                    const error = (data && data.message) || response.status;
                    return Promise.reject(error);
                }
  
                if(data.status === true)
                {
                    toast.success(data.message)
                    localStorage.setItem('user-data', JSON.stringify(data.data));
                }else{
                    toast.error(data.message)
                }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
    }

    return (
            <div className="container rounded bg-white mt-5 mb-5">
                <div className="row">
                    <div className="col-md-2 border-right">
                        <div className="d-flex flex-column align-items-center text-center prf-img-set">
                        {
                            show ? <img src={image.preview} className="rounded-circle mt-5" height="150px" width="150px" /> :
                            image.preview && <img src={HTTPURL+'images/'+image.preview} className="rounded-circle mt-5" height="150px" width="150px" /> 
                        }
                        </div>
                    </div>
                    <div className="col-md-7 border-right">
                        <div className="p-3 py-5">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="text-right">Profile Settings</h4>
                            </div>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row mt-2">
                                    <div className="col-md-6">
                                        <Form.Field>
                                            <label className="form-label" htmlFor="form3Example1m">First name</label>
                                            <input
                                                placeholder='First Name'
                                                type="text"
                                                {...register("firstName", { required: true, maxLength: 10 })}
                                                className="form-control form-control-lg"
                                            />
                                        </Form.Field>
                                        {errors.firstName && errors.firstName.type === "required" && <span className="validation-error">This is required</span>}
                                        {errors.firstName && errors.firstName.type === "maxLength" && <span className="validation-error">Max length is 10</span>}
                                    </div>
                                    <div className="col-md-6">
                                        <Form.Field>
                                            <label className="form-label" htmlFor="form3Example1m">Middle name</label>
                                            <input
                                                placeholder='Middle Name'
                                                type="text"
                                                {...register("middleName", { required: true, maxLength: 10 })}
                                                className="form-control form-control-lg"
                                            />
                                        </Form.Field>
                                        {errors.middleName && errors.middleName.type === "required" && <span className="validation-error">This is required</span>}
                                        {errors.middleName && errors.middleName.type === "maxLength" && <span className="validation-error">Max length is 10</span>}
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-6">
                                    <Form.Field>
                                        <label className="form-label" htmlFor="form3Example1m">Last name</label>
                                        <input
                                            placeholder='Last Name'
                                            type="text"
                                            {...register("lastName", { required: true, maxLength: 10 })}
                                            className="form-control form-control-lg"
                                        />
                                    </Form.Field>
                                    {errors.lastName && errors.lastName.type === "required" && <span className="validation-error">This is required</span>}
                                    {errors.lastName && errors.lastName.type === "maxLength" && <span className="validation-error">Max length is 10</span>}
                                    </div>
                                    <div className="col-md-6">
                                    <Form.Field>
                                        <label className="form-label" htmlFor="form3Example1m">Date of Birth</label>
                                        <input
                                            placeholder='Date of Birth'
                                            type="date"
                                            {...register("dob", { required: true})}
                                            className="form-control form-control-lg"
                                        />
                                    </Form.Field>
                                    {errors.dob && errors.dob.type === "required" && <span className="validation-error">This is required</span>}
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-6">
                                    <Form.Field>
                                            <label className="form-label" htmlFor="form3Example1m">Gender</label>
                                            <div className="form-check form-check-inline mb-0 me-4">
                                                <input
                                                    {...register("gender", { required: true })}
                                                    type="radio"
                                                    value="0"
                                                    id="male"
                                                    className="form-check-input"
                                                />
                                                Male
                                            </div>
                                            <div className="form-check form-check-inline mb-0 me-4">
                                                <input
                                                    {...register("gender", { required: true })}
                                                    type="radio"
                                                    value="1"
                                                    id="female"
                                                    className="form-check-input"
                                                />
                                                Female
                                            </div>
                                            {errors.gender && errors.gender.type === "required" && <span className="validation-error">This is required</span>}
                                        </Form.Field>
                                    </div>
                                    <div className="col-md-6">
                                        <Form.Field>
                                            <label className="form-label" htmlFor="form3Example1m">Phone Number</label>
                                            <input
                                                placeholder='Phone Number'
                                                type="text"
                                                {...register("phone", { required: true, maxLength: 10})}
                                                className="form-control form-control-lg"
                                            />
                                        </Form.Field>
                                        {errors.phone && errors.phone.type === "required" && <span className="validation-error">This is required</span>}
                                        {errors.phone && errors.phone.type === "maxLength" && <span className="validation-error">Max length is 10</span>}
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-6">
                                    <Form.Field>
                                            <label className="form-label" htmlFor="Email Address">Email Address</label>
                                            <input
                                                placeholder='Email Address'
                                                type="email"
                                                {...register("email",
                                                    {
                                                        required: true,
                                                        //eslint-disable-next-line
                                                        pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                                    })}
                                                className="form-control form-control-lg"
                                                readOnly
                                            />
                                        </Form.Field>
                                        {errors.email && errors.email.type === "required" && <span className="validation-error">This is required</span>}
                                        {errors.email && errors.email.type === "pattern" && <span className="validation-error">Must be a valid email</span>}
                                    </div>
                                    <div className="col-md-6">
                                        <Form.Field>
                                            <label className="form-label" htmlFor="Education">Education</label>
                                            <select
                                                {...register("education")}
                                            >
                                            <option value="">Select</option>
                                            {
                                                education && education.map((mini,index) => {
                                                    return  <option key={index} value={mini.id}>{mini.name}</option>
                                                })
                                            }
                                            </select>
                                        </Form.Field>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-6">
                                    <Form.Field>
                                            <label className="form-label" htmlFor="workVocation">Work/Vocation</label>
                                            <select
                                                // {...register("state", { required: true})}
                                                {...register("workVocation")}
                                            >
                                            <option value="">Select</option>
                                            {
                                                workVocation && workVocation.map((state,index) => {
                                                    return <option key={index} value={state.id}>{state.name}</option>
                                                })
                                            }
                                            </select>
                                        </Form.Field>
                                    </div>
                                    <div className="col-md-6">
                                    <Form.Field>
                                            <label className="form-label" htmlFor="Photo">Photo</label>
                                            <input
                                                placeholder='Photo'
                                                type="file"
                                                {...register("photo")}
                                                className="form-control form-control-lg"
                                                onChange={handleFileChange}
                                                accept="image/*"
                                            />
                                        </Form.Field>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-6">
                                        <Form.Field>
                                            <label className="form-label" htmlFor="Category">Category</label>
                                            <select
                                                {...register("category", { required: true})}
                                            >
                                            <option value="">Select</option>
                                            {
                                                category && category.map((val,index) => {
                                                    return <option key={index} value={val.id}>{val.name}</option>;
                                                })
                                            }
                                            </select>
                                        </Form.Field>
                                        {errors.category && errors.category.type === "required" && <span className="validation-error">This is required</span>}
                                    </div>    
                                    <div className="col-md-6">
                                        <Form.Field>
                                                <label className="form-label" htmlFor="Sub Category">Sub Category</label>
                                                <select
                                                    {...register("subcategory", { required: true})}
                                                >
                                                <option value="">Select</option>
                                                {
                                                    subCategory && subCategory.map((subCat,index) =>
                                                    {
                                                        return <option key={index} value={subCat.id}>{subCat.name}</option>
                                                    })
                                                }
                                                </select>
                                        </Form.Field>
                                        {errors.subcategory && errors.subcategory.type === "required" && <span className="validation-error">This is required</span>}
                                        <Form.Field>
                                            <input 
                                                type="hidden"
                                                value=""
                                                {...register('id')}
                                            />
                                        </Form.Field>
                                    </div>
                                </div>
                                <div className="mt-3"><button className="btn btn-primary profile-button sap-btn-dark" type="submit">Update Profile</button></div>
                            </Form>
                        </div>
                    </div>
                    <div className="col-md-3 edit-prf">
                        <div className="p-3 py-5">
                            <div className="col-md-12">
                                    <label className="labels"> <i className='fas fa-graduation-cap'></i><span className="ms-1">Profile Information</span></label>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <label className="labels"> <i className='fas fa-user-secret'></i><span className="ms-1">Security</span></label>
                            </div> 
                            <br />
                            <div className="col-md-12">
                                    <div className="row">
                                        <label className="">
                                            <span className="d-flex align-items-center"><i className="fa fa-circle-oms-2"></i><div className="ms-2">Adedayo Omoboboye</div></span>
                                            <span className="d-block">ID: 201123</span>
                                            </label>
                                        
                                            <label>Your Progress</label>
                                            <p>You are currently in week 1 of 12</p>
                                                <div className="col-md-12">
                                                <div className="progress">
                                                <div className="progress-bar" style={{width: "40%"}}></div>
                                            </div>
                                            <p>4% Completed</p>                                                
                                                </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default Setting;